import { inject, injectable } from 'inversify';
import ProductsService from 'src/features/products/data/service/ProductsService';

import {
  CategoryPromotionalProductsParams,
  GetProductsOnPromotionFilteredUseCaseInterface,
} from 'src/features/products/domain/useCases/types';
import { PaginatedResponse, Product } from 'src/types/common';

@injectable()
class CategoryPromotionalProductsUseCase
  implements GetProductsOnPromotionFilteredUseCaseInterface
{
  @inject(ProductsService) private productsService!: ProductsService;

  async execute(params: CategoryPromotionalProductsParams) {
    const response = await this.productsService.getProductsOnPromotion(params);

    return response.data as PaginatedResponse<Product>;
  }
}

export default CategoryPromotionalProductsUseCase;
